'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { INTERACTIVE_SURFACE } from '@common/components/interaction';
import { useClipboard } from '@common/hooks';
import SvgAlignBack from '@common/icon/SvgAlignBack';
import SvgChevrondown from '@common/icon/SvgChevrondown';
import { cn } from '@core/utils';
import type { GuideChannelKey } from '../../_utils/guide/guideContent';
import { GUIDE_CHANNELS, GUIDE_KEYWORDS, sampleTextOf } from '../../_utils/guide/guideContent';
import { AD_NOTICE } from '../../_utils/labels';
import { ChannelMark } from '../link-card/ChannelMark';
interface GuideSectionProps {
  channel: GuideChannelKey;
  linkUrl?: string;
  isCollapsible?: boolean;
}
export const GuideSection = t0 => {
  const $ = _c(46);
  const {
    channel,
    linkUrl,
    isCollapsible: t1
  } = t0;
  const isCollapsible = t1 === undefined ? true : t1;
  const copyToClipboard = useClipboard();
  let t2;
  if ($[0] !== channel) {
    t2 = GUIDE_CHANNELS.find(item => item.key === channel);
    $[0] = channel;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const guide = t2;
  let t3;
  if ($[2] !== channel || $[3] !== linkUrl) {
    t3 = [AD_NOTICE, ...sampleTextOf(channel, linkUrl)];
    $[2] = channel;
    $[3] = linkUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const sample = t3.join("\n");
  let t4;
  if ($[5] !== channel) {
    t4 = <ChannelMark channel={channel} className="xl:size-28 xl:rounded-xsmall" />;
    $[5] = channel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = guide?.tab;
  let t6;
  if ($[7] !== t5) {
    t6 = <span className="flex-1 font-700 text-Gray-900 typo-body3">{t5}</span>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const heading = t7;
  const t8 = guide?.tip;
  let t9;
  if ($[12] !== t8) {
    t9 = <p className="font-500 text-Gray-900 typo-body4">{t8}</p>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="font-700 text-Gray-600 typo-body4">필수 키워드</p>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex flex-col gap-8 xl:gap-12">{t10}<ul className="flex flex-wrap gap-4">{GUIDE_KEYWORDS.map(_temp)}</ul></div>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="font-700 text-Gray-600 typo-body4">샘플 콘텐츠 · 수정 후 복사</p>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== copyToClipboard || $[18] !== sample) {
    t13 = () => copyToClipboard({
      value: sample,
      message: "\uB0B4\uC6A9\uBCF5\uC0AC \uC644\uB8CC!"
    });
    $[17] = copyToClipboard;
    $[18] = sample;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SvgAlignBack aria-hidden={true} className="size-12 text-Gray-600" />;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13) {
    t15 = <div className="flex items-center justify-between gap-8">{t12}<Button theme="sub-line" dimensions="H32" className="shrink-0" onClick={t13}>{t14}내용 복사</Button></div>;
    $[21] = t13;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== sample) {
    t16 = <p className="whitespace-pre-line break-keep rounded-xsmall border border-Gray-300 bg-Gray-white px-16 py-12 text-Gray-900 typo-body3">{sample}</p>;
    $[23] = sample;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t15 || $[26] !== t16) {
    t17 = <div className="flex flex-col gap-16">{t11}<div className="flex flex-col gap-8 xl:gap-12">{t15}{t16}</div></div>;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="flex flex-col gap-4 typo-caption1"><p className="text-Gray-700">링크를 복사하면 첫 줄에 아래 내용이 함께 들어가요.</p><p className="text-Gray-900">{AD_NOTICE}</p></div>;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t17) {
    t19 = <div className="flex flex-col gap-16 xl:gap-12">{t17}{t18}</div>;
    $[29] = t17;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t19 || $[32] !== t9) {
    t20 = <div className="flex flex-col gap-16 pt-16 xl:gap-28">{t9}{t19}</div>;
    $[31] = t19;
    $[32] = t9;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  const body = t20;
  if (!isCollapsible) {
    let t21;
    if ($[34] !== heading) {
      t21 = <div className="flex items-center gap-8">{heading}</div>;
      $[34] = heading;
      $[35] = t21;
    } else {
      t21 = $[35];
    }
    let t22;
    if ($[36] !== body || $[37] !== t21) {
      t22 = <div className="rounded-small bg-Gray-25 p-16">{t21}{body}</div>;
      $[36] = body;
      $[37] = t21;
      $[38] = t22;
    } else {
      t22 = $[38];
    }
    return t22;
  }
  let t21;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = cn(INTERACTIVE_SURFACE, "-m-8 flex cursor-pointer list-none items-center gap-8 rounded-xsmall p-8 [&::-webkit-details-marker]:hidden");
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <SvgChevrondown aria-hidden={true} className="size-20 text-Gray-500 group-open:rotate-180" />;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== heading) {
    t23 = <summary className={t21}>{heading}{t22}</summary>;
    $[41] = heading;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== body || $[44] !== t23) {
    t24 = <details open={true} className="group rounded-small bg-Gray-25 p-16">{t23}{body}</details>;
    $[43] = body;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  return t24;
};
function _temp(keyword) {
  return <li key={keyword} className="flex h-32 items-center rounded-pill border border-Gray-300 bg-Gray-white px-12 text-Gray-700 typo-body4">{keyword}</li>;
}